module.exports = __webpack_public_path__ + "static/media/chat10.23e13bc1.svg";